import { Row, Col, Card, CardBody, Label, Button } from 'reactstrap';
import { VerificationState } from '../../../features/ingest/ingestSlice';
import verificationActions from '../../../features/ingest/verificationActions';
import mappingActions from '../../../features/ingest/mappingActions';
import { useDispatch } from 'react-redux';

export default (state: VerificationState) => {
  return (
    <>
      <Row className="tpicap-important-text mb-3 ml-3">
        <Col>
          <div>Number of Rows with Errors: {state.rowsWithErrors}</div>
        </Col>
      </Row>
      <Row className="tpicap-important-text mb-3 ml-3">
        <Col>
          <div>Number of Row-level Errors: {state.numberOfErrors}</div>
        </Col>
      </Row>
      <Row className="tpicap-important-text mb-3 ml-3">
        <Col>
          <div>
            Number of Potential Duplicate Rows: {state.numberOfDuplicateRows}
          </div>
        </Col>
      </Row>
    </>
  );
};
